export var SurveyEvent;
(function (SurveyEvent) {
    SurveyEvent["surveyResponse"] = "SURVEY_RESPONSE";
    SurveyEvent["emailVerification"] = "EMAIL_VERIFICATION";
    SurveyEvent["otpVerfication"] = "OTP_VERIFICATION";
})(SurveyEvent || (SurveyEvent = {}));
